import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import infoList from "@/mixins/infoList";
import { banIpList, unbanIpLogin } from "@/api/role";
import { getGameServerMap, getUserInfoMap } from "@/utils/dictionary";
import BanSomeIp from "./components/banSomeIp.vue";
import BanRoleLogin from "./components/banRoleLogin.vue";
export default {
  components: {
    BanSomeIp: BanSomeIp,
    BanRoleLogin: BanRoleLogin
  },
  name: "userBanned",
  mixins: [infoList],
  data: function data() {
    return {
      centerDialogVisible: false,
      banRoleDialog: false,
      listApi: banIpList,
      serverId: "",
      searchInfo: {},
      serverList: {},
      userList: {},
      banForm: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getGameServerMap();
          case 2:
            _this.serverList = _context.sent;
            _context.next = 5;
            return getUserInfoMap();
          case 5:
            _this.userList = _context.sent;
            _this.getTableData();
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    //改变switch开关
    changeWords: function changeWords(row, e) {
      if (e == false) {
        row.type = "";
        row.Forbidden_words = "";
      }
    },
    backPerson: function backPerson(res) {
      this.centerDialogVisible = res.isback;
      this.getTableData();
    },
    //直接调查询接口
    queryEvent: function queryEvent() {
      this.getTableData();
      if (this.tableData.length === 0) {
        this.$message({
          message: "暂无数据"
        });
      }
    },
    openBox: function openBox() {},
    unBanOpenid: function unBanOpenid(ip) {
      var _this2 = this;
      console.log("-------------------");
      var unbanRoleData = {
        ip_list: [ip]
      };
      unbanIpLogin(unbanRoleData).then(function (res) {
        if (res.code == 0) {
          _this2.getTableData();
        }
      });
    },
    banRole: function banRole(server_id, role_id) {
      this.banForm.serverId = server_id;
      this.banForm.roleId = role_id;
      this.banRoleDialog = true;
    },
    banFinish: function banFinish() {
      this.banRoleDialog = false;
      this.getTableData();
    }
  }
};